import * as Constants from './constants'

export const toggleUserMenu = () => ({type: Constants.TOGGLE_USER_MENU})
export const clickOutside = () => ({type: Constants.CLICK_OUTSIDE})



// WEBPACK FOOTER //
// ./src/components/menu/user-menu/actions.ts